/* eslint no-eval: 0 */
import forEach from "lodash/forEach";
import store from "../store";

export default class PollQuestion {
  constructor(page, index, options) {
    this.options = options;
    this.page = page;
    this.index = index;
  }
  getId() {
    const id = this.options.id || `page ${this.page} index ${this.index}`;
    return id;
  }
  getFieldId() {
    return `field ${this.options.id ||
      `page ${this.page} index ${this.index}`}`;
  }
  getLabel() {
    let label = this.options.label;
    if (this.options.number) {
      label = `${this.options.number}. ${label}`;
    }
    return label;
  }
  getLabelWidth() {
    return this.options.labelWidth || "is-two-fifths";
  }
  getLabelAlign() {
    return this.options.labelRight ? "has-text-right" : "";
  }
  getType() {
    return this.options.type || "text";
  }
  multiline() {
    return this.options.multiline || false;
  }
  getRadioOptions() {
    return this.options.options || [];
  }
  labelStrong() {
    if (typeof this.options.labelStrong === "undefined") {
      return true;
    }
    return this.options.labelStrong;
  }
  textStrong() {
    if (typeof this.options.textStrong === "undefined") {
      return false;
    }
    return this.options.textStrong;
  }

  onChange(value) {
    if (typeof this.options.onChange === "undefined") {
      return null;
    }
    const formValues = store.getState().form.pollForm.values;
    // wartosc przed zmiana w momencie zdarzenia
    let actualValue = formValues[value.target.name];
    if (typeof actualValue === "undefined") 
      actualValue=false;
    if (typeof this.options.onChange[actualValue] !== "undefined") {
      //  console.log(this.options.onChange[actualValue]);
      forEach(this.options.onChange[actualValue], (vValue, vKey) => {
        formValues[vKey] = vValue;
      });
    }
    // store.getState().form.pollForm.values.ankieta_zgodaZdrowie = "1";
    return null;
  }

  hide(observed) {
    // jesli jedna wartosc w options.show,  observed zawiera jej wartosc
    // jesli wiecej - observed zawiera obiekt
    if (this.depending()) {
      let show = true;
      const showList = this.options.show;
      showList.map(element => {
        let elementValue = null;
        if (showList.length === 1) {
          elementValue = observed;
        } else {
          elementValue = observed[element[0]];
        }
        // sprawdzamy warunek logiczny i decydujemy czy pokazac
        // ustawiamy show na false jesli choc jeden z warunkow nie jest spelniony
        if (element.length === 1) {
          if (!elementValue) show = false;
        } else {
          // teraz na drugim miejscu jest wyrazenia logiczne
          const toEvaluate = `elementValue ${element[1]}`;
          if (!eval(toEvaluate)) show = false;
        }
        return null;
      });
      return !show;
    }
    return false;
  }
  dependsOn() {
    const list = (this.options.show || []).map(element => element[0]);
    // console.log(list);
    return list;
  }
  depending() {
    if ((this.options.show || []).length > 0) return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/PollQuestion.js